import { Suspense, useEffect } from "react";
import AppRoutes from "./view/components/routes/AppRoutes";
import Loader from "./view/components/shared/Loader";
import { getEnvVariable } from "./constants/brandConfig";
import { BRAND_NAME, META_TITLE, META_DESCRIPTION, domain } from "./constants/Branding";
import { initBrandTracking } from "./constants/Tracking";
import { store } from "./App.utils";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { SignUpModalProvider } from "./view/context/SignUpModalContext";
import { ResendEmailModalProvider } from "./view/context/ResendEmailModalContext";
import { ForgotPasswordModalProvider } from "./view/context/ForgotPasswordModalContext";
import AppErrorBoundary from "./view/components/shared/AppErrorBoundary";

function App() {
  const updateFavicon = () => {
    let link: any = document.querySelector("link[rel~='icon']");

    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    link.setAttribute("href", getEnvVariable(domain, "favicon"));
  };

  const updateTitle = () => {
    document.title = META_TITLE || BRAND_NAME;
  };

  const updateMetaDescription = () => {
    if (!META_DESCRIPTION) return;

    let meta: any = document.querySelector("meta[name='description']");

    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }

    meta.setAttribute("content", META_DESCRIPTION);
  };

  useEffect(() => {
    // Load favicon
    updateFavicon();
    // Update title
    updateTitle();
    // Set this brand's meta description, if configured
    updateMetaDescription();
    // Init this brand's Facebook Pixel / GTM, if configured
    initBrandTracking();
  }, []);
  
  return (
    <div className="h-full">
      <Provider store={store}>
        <SignUpModalProvider>
          <ResendEmailModalProvider>
            <ForgotPasswordModalProvider>
              <Suspense fallback={<Loader />}>
                <AppErrorBoundary>
                  <AppRoutes />
                </AppErrorBoundary>
              </Suspense>
              <ToastContainer />
            </ForgotPasswordModalProvider>
          </ResendEmailModalProvider>
        </SignUpModalProvider>
      </Provider>
    </div>
  );
}

export default App;
